/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MissionOverlapAcknowledgementDto } from './missionOverlapAcknowledgementDto';
import { SimpleMissionDto } from './simpleMissionDto';

/**
 * Details about a mission boundary overlap and its acknowledgement status.
 */
export interface MissionOverlapDto {
    overlappingMission: SimpleMissionDto;
    status: MissionOverlapDto.Status;
    acknowledgementList: Array<MissionOverlapAcknowledgementDto>;
}
export namespace MissionOverlapDto {
    export type Status = 'EXCLUDED' | 'INFORMATIONAL' | 'APPLICABLE';
    export const Status = {
        EXCLUDED: 'EXCLUDED' as Status,
        INFORMATIONAL: 'INFORMATIONAL' as Status,
        APPLICABLE: 'APPLICABLE' as Status
    };
}
